export class EntityAlreadyExistsError extends Error {
  constructor(message) {
    super(message);
  }
}

